import { render, staticRenderFns } from "./prihodList.vue?vue&type=template&id=f9ffef9a&scoped=true&"
import script from "./prihodList.vue?vue&type=script&lang=js&"
export * from "./prihodList.vue?vue&type=script&lang=js&"
import style0 from "./prihodList.vue?vue&type=style&index=0&id=f9ffef9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ffef9a",
  null
  
)

export default component.exports